/**
 * Generated runtime TestId mirror for frontend/src/features/outbound-connectors/components/forms/DatabaseConfigCard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const DatabaseConfigCardTestIds = {
  btnCreateDatabaseConfig: "btn-create-database-config",
  btnEditDatabaseConfig: "btn-edit-database-config",
  cardTitleDatabaseConfig: "card-title-database-config",
  databaseConfigCard: "database-config-card",
  selectDatabaseType: "select-database-type"
} as const;
